import * as THREE from "three";
import { defineModel, type Part, type Variant } from "../../lib";

// A large faceted rock. A static model whose three *variants* are weathering
// situations — mossy, bare and cracked — rather than animation states. This is
// the canonical example of using `variants` for "the same object in different
// situations": each is a self-contained `parts()`.
function rock(bodyTint: string, capTint: string, extra: Part[] = []): () => Part[] {
  return () => [
    { geometry: new THREE.IcosahedronGeometry(0.46, 0), color: bodyTint, position: [0, 0.32, 0], scale: [1.15, 0.95, 1.05] },
    { geometry: new THREE.IcosahedronGeometry(0.22, 0), color: capTint, position: [0.28, 0.16, 0.12] },
    ...extra,
  ];
}

const variants: Variant[] = [
  { id: "mossy", label: "Mossy", description: "Weathered grey stone with a moss cap.",
    parts: rock("#7e8189", "#6b6e75", [
      { geometry: new THREE.IcosahedronGeometry(0.3, 0), color: "#5a7d3a", position: [-0.05, 0.55, 0], scale: [1.1, 0.4, 1.1] },
    ]) },
  { id: "bare", label: "Bare", description: "Clean, dry granite.",
    parts: rock("#888b91", "#73767d") },
  { id: "cracked", label: "Cracked", description: "A darker boulder split by a deep fissure.",
    parts: rock("#73767d", "#5f6268", [
      { geometry: new THREE.BoxGeometry(0.04, 0.7, 0.5), color: "#3c3e44", position: [0.02, 0.34, 0], rotation: [0, 0.3, 0.08] },
    ]) },
];

export const boulder = defineModel({
  id: "boulder",
  batchId: "standard",
  name: "Boulder",
  tags: ["nature", "rock", "stone", "scenery"],
  summary: "A large faceted boulder with mossy, bare and cracked variants.",
  author: "age-of-mcp",
  footprint: 0.55,
  variants,
  animations: [],
});
